import gql from "graphql-tag";

export default gql`
  mutation EmitSignal($signal: SignalType!, $payload: JSON!) {
    emitSignal(signal: $signal, payload: $payload)
  }
`;
